import { CostCenterAssignmentsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export interface CostCentersProps {
  resourceId: number
  skipQueries?: boolean
}

const useCostCentersAssignments = ({ resourceId, skipQueries = false }: CostCentersProps) => {
  const { company } = useCurrentSession()

  const { data, loading, refetch } = useQuery(CostCenterAssignmentsDocument, {
    variables: {
      companyId: company.id,
      resourceId,
    },
    skip: skipQueries,
  })

  const canManageCostCenterMemberships =
    data?.employees.employee?._policies?.manageCostCenterMembershipsFor.can ?? false

  const assignments = data?.finance.costCenterMembershipsConnection.nodes || []

  return {
    isLoading: loading,
    canManageCostCenterMemberships,
    assignments,
    refetch,
  }
}

export default useCostCentersAssignments
